// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-d44c5c7a] .el-upload{width:100%!important}[data-v-d44c5c7a] .el-upload-dragger{width:100%!important;background:#fbfbfb}[data-v-d44c5c7a] .el-upload-list{display:flex;flex-wrap:wrap}[data-v-d44c5c7a] .el-upload-list li{background:#f8fafb;width:49%;margin-left:1%}", ""]);
// Exports
module.exports = exports;
